import { render, staticRenderFns } from "./PeppolSendOptionsModal.vue?vue&type=template&id=46c0ef48&scoped=true"
import script from "./PeppolSendOptionsModal.vue?vue&type=script&lang=ts"
export * from "./PeppolSendOptionsModal.vue?vue&type=script&lang=ts"
import style0 from "./PeppolSendOptionsModal.vue?vue&type=style&index=0&id=46c0ef48&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c0ef48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46c0ef48')) {
      api.createRecord('46c0ef48', component.options)
    } else {
      api.reload('46c0ef48', component.options)
    }
    module.hot.accept("./PeppolSendOptionsModal.vue?vue&type=template&id=46c0ef48&scoped=true", function () {
      api.rerender('46c0ef48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/PeppolSendOptionsModal.vue"
export default component.exports